module.exports = __webpack_public_path__ + "img/star-1.77a280e9.svg";